import { render } from "./JobSummary.vue?vue&type=template&id=063bf38a&scoped=true"
import script from "./JobSummary.vue?vue&type=script&lang=js"
export * from "./JobSummary.vue?vue&type=script&lang=js"

import "./JobSummary.vue?vue&type=style&index=0&id=063bf38a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ccjoe\\Documents\\CC2\\CareControlJobs\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063bf38a"]])

export default __exports__